export default {
    TEREA_PROFILE: 'profile-0x54503234',
    LEVIA_PROFILE: 'profile-0x42503200',
};
